import React, { useEffect } from 'react'

import AddNewUserComp from '../../Components/addNewUserComp/AddNewUserComp';
import Myprofile from '../myprofile/Myprofile';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountUserDetailsThunk } from '../../../../Website/redux/AccountUserSlice';
import EditUser from '../../Components/addNewUserComp/EditUserComp';


const EditAccountUser = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const { loading } = useSelector((state) => state.accountUser)
    useEffect(() => {
        dispatch(getAccountUserDetailsThunk(id))
    }, [])


    if (loading) {
        return <div>please wait..</div>
    }

    return (
        <>
            <Myprofile>
                <EditUser/>
            </Myprofile>

        </>
    )
}

export default EditAccountUser